export const capitalizeFirstLetter = (string: any) => {
  return string?.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, (letter: any) => letter.toUpperCase());
};
